<template>
    <div>
        <public-menu></public-menu>
        <shop-search></shop-search>
        <bottom-nav></bottom-nav>
        <public-footer></public-footer>
    </div>
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Shopsearch from "@/components/shop/shopsearch/shopsearch"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../../components/Footer.vue"
export default{
    components:{
        'public-menu': Public_menu,
        'shop-search':Shopsearch,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer
    }
}
</script>

<style scoped>
@import url('../../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/shop/shopsearch/shopsearch.vue